import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ListItem } from './model/list-item';

@Component({
	selector: 'app-list-confirmation',
	templateUrl: './list-confirmation.component.html',
	styleUrls: ['./list-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ListConfirmationComponent implements OnInit {

	@Input() justList = false;
	@Input() list: Array<ListItem> = [];

	constructor() { }
	
	ngOnInit() { }

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/list-confirmation/list-confirmation.component.ts